import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { EventType } from '../../models/EventType';
import { SelectedObj } from '../../models/ExchangeSportsState';
import { SPORTS_ICONS } from '../../constants/SportsNavView';
import { RootState } from '../../models/RootState';
import { isMobile } from 'react-device-detect';
import { setEventType, fetchCompetitions, setCompetition } from '../../store';
import InplayImg from '../../assets/images/sportsbook/icons/inplay.png';
import IPLIcon from '../../assets/images/sportsbook/icons/IPL-WINNER.png';

import WorldCupImg from '../../assets/images/sportsbook/world_cup.png';
import BBLImg from '../../assets/images/sportsbook/icons/bbl.png';
import AUMen from '../../assets/images/sportsbook/icons/au_men.png';
import AUWomen from '../../assets/images/sportsbook/icons/au_women.png';
import { CONFIG_PERMISSIONS } from '../../constants/ConfigPermission';
import {
  OTHER_EVENTS,
  EXCH_SPORTS_MAP,
} from '../../constants/ExchangeEventTypes';
import BinaryIcon from '../../assets/images/sportsbook/icons/binary.png';
import { BBL_MEN, IPL_CUP } from '../../constants/IPLEvent';
import './ExchangeSportsListNav.scss';

type PropType = {
  eventTypes: EventType[];
  selectedEventType: SelectedObj;
  allowedConfig: number;
  setEventType: (eventType: SelectedObj) => void;
  setCompetition: (eventType: SelectedObj) => void;
  fetchCompetitions: (eventTypeId: string) => void;
};

const ExchangeSportsListNav: React.FC<PropType> = (props) => {
  const {
    eventTypes,
    selectedEventType,
    allowedConfig,
    setEventType,
    setCompetition,
    fetchCompetitions,
  } = props;

  const [tabValue, setTabValue] = useState<number>(0);

  const handleTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setTabValue(newValue);
  };

  const handleSportChange = (sport) => {
    setCompetition({ id: '', name: '', slug: '' });
    setEventType({ id: sport.id, name: sport.name, slug: sport.slug });
    fetchCompetitions(sport.id);
  };

  useEffect(() => {
    for (let i = 0; i < eventTypes.length; i += 1) {
      if (eventTypes[i].slug === selectedEventType.slug) {
        setTabValue(i);
        break;
      }
    }
  }, [selectedEventType, eventTypes]);

  return (
    <div className="exch-sports-nav-list">
      <Tabs
        className="exch-sports-list"
        value={tabValue}
        onChange={handleTabChange}
        variant="scrollable"
        scrollButtons="auto"
      >
        {(allowedConfig & CONFIG_PERMISSIONS.sports) !== 0 ? (
          <NavLink
            className="nav-link inplay-nav-link"
            activeClassName="nav-selected"
            to="/exchange_sports/inplay"
          >
            <Tab
              className="sport-name"
              label={'InPlay'}
              icon={
                <img
                  className={'sport-icon'}
                  alt={'InPlay'}
                  title={'InPlay'}
                  src={InplayImg}
                />
              }
              value={0}
            />
          </NavLink>
        ) : null}

        {/* {(allowedConfig & CONFIG_PERMISSIONS.cricket) !== 0 ? (
          <NavLink
            className="nav-link "
            to={`/exchange_sports/cricket/indian-premier-league/indian-premier-league/${btoa(
              IPL_CUP.routeHash
            )}`}
            activeClassName="nav-selected"
          >
            <Tab
              className="sport-name"
              label="IPL WINNER"
              icon={
                <img
                  className="sport-icon ipl ipl-winner-icon"
                  alt="cricket"
                  title="cricket"
                  src={IPLIcon}
                />
              }
            />
          </NavLink>
        ) : null} */}

        {eventTypes.map((sport, index) =>
          (allowedConfig & Number(EXCH_SPORTS_MAP[sport.slug])) !== 0 ? (
            // (EXCH_SPORTS_MAP[sport.slug] & allowedConfig) !== 0 ? (
            <NavLink
              className="nav-link"
              activeClassName="nav-selected"
              exact={true}
              key={index}
              onClick={() => {
                handleSportChange(sport);
              }}
              to={`/exchange_sports/${sport.slug}`}
            >
              <Tab
                className="sport-name"
                label={sport.name}
                icon={
                  <img
                    className={'sport-icon ' + sport.slug}
                    alt={sport.slug}
                    title={sport.slug}
                    src={
                      SPORTS_ICONS[sport.name.replace(/\s/g, '')]
                        ? SPORTS_ICONS[sport.name.replace(/\s/g, '')]
                        : SPORTS_ICONS['Other']
                    }
                  />
                }
                value={index + 1}
              />
            </NavLink>
          ) : null
        )}

        {/* {(allowedConfig & CONFIG_PERMISSIONS.live_casino) !== 0 &&
        ALLOW_CASINO ? (
          <NavLink className="nav-link casino-nav-link" to="/casino">
            <Tab
              className="sport-name"
              label="Live Casino"
              icon={
                <img
                  className="sport-icon live-casino"
                  src={CasinoImg}
                  alt="live"
                />
              }
              value={eventTypes.length + 2}
            />
            <img className="nav-selected" src={checkMarkImg} alt="selected" />
          </NavLink>
        ) : null} */}

        {/* {(allowedConfig & CONFIG_PERMISSIONS.cricket) !== 0 ? (
          <NavLink
            className="nav-link "
            to={`/exchange_sports/cricket/ipl/winner/${btoa(
              IPL_CUP.routeHash
            )}`}
            activeClassName="nav-selected"
          >
            <Tab
              className="sport-name"
              label="IPL WINNER"
              icon={
                <img
                  className="sport-icon ipl"
                  alt="cricket"
                  title="cricket"
                  src={IplImg}
                />
              }
            />
          </NavLink>
        ) : null} */}

        {/* {(allowedConfig & CONFIG_PERMISSIONS.cricket) !== 0 ? (
          <NavLink
            className="nav-link "
            to={`/virtual_sports`}
            activeClassName="nav-selected"
          >
            <Tab
              className="sport-name"
              label="Virtual Sports"
              icon={
                <img
                  className="sport-icon ipl"
                  alt="cricket"
                  title="cricket"
                  src={IplImg}
                />
              }
            />
          </NavLink>
        ) : null} */}

        {/* {(allowedConfig & CONFIG_PERMISSIONS.tennis) !== 0 ? (
          <NavLink
            className="nav-link "
            to={`/exchange_sports/tennis/australian-open-men-s/winner/${btoa(
              AU_OPEN_MENS.routeHash
            )}`}
            activeClassName="nav-selected"
          >
            <Tab
              className="sport-name"
              label="AUSTRALIAN OPEN MEN'S"
              icon={
                <img
                  className="sport-icon ipl"
                  alt="tennis"
                  title="tennis"
                  src={AUMen}
                />
              }
            />
          </NavLink>
        ) : null}

        {(allowedConfig & CONFIG_PERMISSIONS.tennis) !== 0 ? (
          <NavLink
            className="nav-link "
            to={`/exchange_sports/tennis/Australian%20Open%202022/australian-open-women-s/${btoa(
              AU_OPEN_WOMENS.routeHash
            )}`}
            activeClassName="nav-selected"
          >
            <Tab
              className="sport-name"
              label="AUSTRALIAN OPEN WOMEN'S"
              icon={
                <img
                  className="sport-icon ipl"
                  alt="tennis"
                  title="tennis"
                  src={AUWomen}
                />
              }
            />
          </NavLink>
        ) : null} */}

        {/* {(allowedConfig & CONFIG_PERMISSIONS.binary) !== 0 ? (
          <NavLink
            className="nav-link "
            to="/exchange_sports/binary"
            activeClassName="nav-selected"
          >
            <Tab
              className="sport-name"
              label="Binary"
              icon={
                <img
                  className="sport-icon"
                  alt="binary"
                  title="binary"
                  src={BinaryIcon}
                />
              }
            />
          </NavLink>
        ) : null} */}

        {/* {OTHER_EVENTS.map((event, index) => (
          <NavLink className="nav-link" to="#">
            <div className="ribbon ribbon-top-right">
              <span> Coming Soon</span>
            </div>
            <Tab
              className="sport-name"
              label={event.label}
              icon={
                <img
                  className={'sport-icon'}
                  alt={event.label}
                  src={event.img}
                  title={event.label}
                />
              }
              value={0}
            />
          </NavLink>
        ))} */}
      </Tabs>
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    eventTypes: state.exchangeSports.eventTypes,
    selectedEventType: state.exchangeSports.selectedEventType,
    allowedConfig: state.common.allowedConfig,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    setEventType: (eventType: SelectedObj) => dispatch(setEventType(eventType)),
    setCompetition: (eventType: SelectedObj) =>
      dispatch(setCompetition(eventType)),
    fetchCompetitions: (eventTypeId: string) =>
      dispatch(fetchCompetitions(eventTypeId)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ExchangeSportsListNav);
